<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="600"
    >
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="封面图"
        align="center"
        min-width="120"
        prop="cover"
      >
        <template slot-scope="scope">
          <img-load
            :width="'80px'"
            :height="'60px'"
            :src="imgUrl + scope.row.img"
          >
          </img-load>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="名称" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.name || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.sort || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status === 1">启用</el-tag>
          <el-tag type="danger" v-if="scope.row.status === 0">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="修改时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updatedAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="180"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="del(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>

    <!-- 新增、修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
      @close="handleClose"
    >
      <el-form :model="form" label-width="100px" :rules="rules" ref="form">
        <el-form-item label="封面图:" prop="cover">
          <base-upload
            class="upload"
            :cover="form.img"
            :action="action"
            wSize="47"
            hSize="47"
            :width="'138.5px'"
            :height="'138.5px'"
            @successCallback="handleAvatarSuccess"
          ></base-upload>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="说明" prop="desc">
          <el-input v-model="form.desc"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model.number="form.sort"></el-input>
        </el-form-item>
        <el-form-item label="跳转方式:" prop="hrefType">
          <el-select
            v-model.number="form.link_type"
            size="small"
            placeholder="跳转方式"
          >
            <el-option
              v-for="item in linkTypeList"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="链接地址"
          prop="link_url"
          v-if="form.link_type == 1"
        >
          <el-input v-model.number="form.link_url"></el-input>
        </el-form-item>
        <el-form-item
          label="链接地址:"
          prop="link_url"
          v-if="form.link_type == 2"
        >
          <el-select
            v-model.number="form.link_url"
            size="small"
            placeholder="链接地址"
            filterable
          >
            <el-option
              v-for="item in linkList"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="内链ID"
          prop="topicId"
          v-if="showLinkId"
        >
          <el-input v-model="topicId"></el-input>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-select v-model="form.status" placeholder="请选择是否启用">
            <el-option
              v-for="item in enables"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="onSubmit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
import baseConfig from "@/utils/serverUrlConfig";
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNum: 1,
        pageSize: 10,
      },
      imgUrl: baseConfig.imgUrl,
      // 图片上传地址
      action: baseConfig.baseServerUrl + "/agent/upload/static",
      enables: [
        { label: "启用", value: 1 },
        { label: "禁用", value: 0 },
      ],
      linkTypeList: [
        { label: "外部浏览器跳转", value: 1 },
        { label: "内部浏览器跳转", value: 2 },
      ],
      linkList: [
        { label: "会员中心", value: "yinseinner://vip_page" },
        { label: "金币钱包", value: "yinseinner://wallet_page" },
        { label: "抽奖", value: "yinseinner://Activity_page" },
        { label: "帖子详情页", value: "yinseinner://postdetail?id=" },
        { label: "视频详情", value: "yinseinner://video_page?id=" },
        { label: "专题导航", value: "yinseinner://navigation" },
        { label: "排行榜", value: "yinseinner://rankingList" },
        { label: "福利任务", value: "yinseinner://taskHall" },
        // { label: "预售界面", value: "yinseinner://advancePage" },
        { label: "亚模块-首页", value: "yinseinner://module?id=" },
        { label: "亚模块-抖音（发现）", value: "yinseinner://module_discover?id=" },
        { label: "亚模块-暗网", value: "yinseinner://darkweb?id=" },
        { label: "亚模块-社区", value: "yinseinner://module_community?id=" },
        { label: "AI科技", value: "yinseinner://Ai_page" },
        // { label: "社区-专题", value: "yinseinner://topics_community?id=" },
      ],
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        link_url: [
          { required: true, message: "请输入链接地址", trigger: "blur" },
        ],
      },
      dialogTitle: "",
      dialogVisible: false,
      form: {
        id: undefined,
        name: "",
        sort: undefined,
        status: 1,
        img: "",
        desc: "",
        link_type: 1,
        link_url: "",
      },
      topicId: "",
    };
  },
  computed: {
    showLinkId() {
      return this.form.link_url.indexOf('id=') > -1
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.queryKingKongList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.form.img = res.data.coverImg;
    },
    // 新增标签配置
    addAndEdit(param) {
      console.log(param);
      this.dialogVisible = true; // 打开新增、编辑对话框
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.name = param.name;
        this.form.img = param.img;
        this.form.desc = param.desc;
        this.form.status = param.status;
        this.form.sort = param.sort ? param.sort : undefined;
        this.form.link_type = param.link_type;
        if (param.link_url.indexOf("id=") > -1) {
          // this.form.link_url = "yinseinner://topic_page";
          const splitArr = param.link_url.split("=");
          this.form.link_url = splitArr[0] + '=';
          this.topicId = splitArr[1];
        } else {
          this.form.link_url = param.link_url;
        }
        
      }
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (
            this.showLinkId &&
            !this.topicId
          ) {
            this.$message({
              type: "error",
              message: "请输入内链ID",
            });
            return;
          }
          if (this.showLinkId) {
            this.form.link_url = this.form.link_url + this.topicId
          }
          API.addKingKong(this.form)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "新增成功",
                });
                this.dialogVisible = false;
                this.getList();
              } else {
                this.$message({
                  type: "error",
                  message: "新增失败",
                });
              }
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: "服务器异常",
              });
            });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (
            this.showLinkId &&
            !this.topicId
          ) {
            this.$message({
              type: "error",
              message: "请输入专题ID",
            });
            return;
          }
          if (this.showLinkId) {
            this.form.link_url = this.form.link_url + this.topicId
          }
          API.modifyKingKong(this.form)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "编辑成功",
                });
                this.dialogVisible = false;
                this.getList();
              } else {
                this.$message({
                  type: "error",
                  message: "编辑失败",
                });
              }
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: "服务器异常",
              });
            });
        } else {
          return false;
        }
      });
    },
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.name}</span>, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.delKingKong(delData)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "success",
                  message: "删除失败!",
                });
              }
              this.getList();
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: "服务器异常!",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.name = "";
      this.form.id = undefined;
      this.form.img = undefined;
      this.form.desc = undefined;
      this.form.sort = undefined;
      this.form.link_url = "";
      this.form.link_type = 1;
      this.form.status = 1;
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
</style>
